import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HubConnectionState } from "@microsoft/signalr";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CruiseControl from "./components/CruiseControl/CruiseControl";
import { CommandType } from "../../enum/CommandType";
import { useIsMobileDetect, useSignalR } from "../../hooks";
import videoService from "../../services/videoService";
import { DirectionControllerWrapper } from "../DirectionController/DirectionControllerWrapper";
import { DraggableCircle } from "../DraggableCircle/DraggableCircle";
import { DroneControlBottomPanel } from "../DroneControlBottomPanel/DroneControlBottomPanel";
import { DroneControlTopPanel } from "../DroneControlTopPanel/DroneControlTopPanel";
import { GAMEPAD_CONTROL_CONSTANTS } from "../GamepadControl/GamepadControl";
import { OperatorActionsHandler } from "../OperatorActionsHandler/OperatorActionsHandler";
export const DroneControlPanel = ({ droneId, children, cameraView, isViewOnly, onDroneConnected, setMuteMic, setMuteAudio, setMicVolume, }) => {
    const { t } = useTranslation();
    const [isStopActive, setIsStopActive] = useState(true);
    const [isStraightFull, setStraightFull] = useState(false);
    const [isBackFull, setBackFull] = useState(false);
    const [isArrowStraight, setArrowStraight] = useState(false);
    const [isArrowRight, setArrowRight] = useState(false);
    const [isArrowBack, setArrowBack] = useState(false);
    const [isArrowLeft, setArrowLeft] = useState(false);
    const [isTurnRight, setTurnRight] = useState(false);
    const [isTurnLeft, setTurnLeft] = useState(false);
    const [currSpeed, setCurrSpeed] = useState(0);
    const [isArmed, setIsArmed] = useState(0);
    const channelsRef = useRef([0, 0, 0, 0, 0, 0, 0]);
    const [controlType, setControlType] = useState(true);
    const [showModalControlTaken, setShowModalControlTaken] = useState(false);
    const [showCruiseControl, setShowCruiseControl] = useState(false);
    const cruiseGasRef = useRef(null);
    const showCruiseControlRef = useRef(false);
    const keyboardGasRef = useRef(null);
    const [isCruiseActive, setIsCruiseActive] = useState(false);
    const [isStickSend, setIsStickSend] = useState(true);
    const isStickSendRef = useRef(isStickSend);
    isStickSendRef.current = isStickSend;
    //const [controlConnection, setControlConnection] = useState<HubConnection | null>(null);
    const [cameras, setCameras] = useState([]);
    const [angles, setAngles] = useState([0, 0, 0]);
    const controlConnection = useSignalR();
    const navigate = useNavigate();
    const mobileActiveRef = useRef(false);
    const keyboardActiveRef = useRef(false);
    const stopIntervalRef = useRef(null);
    const isExitingRef = useRef(false);
    const [isExiting, setIsExiting] = useState(false);
    //let signalUri = `${process.env.REACT_APP_API_URL!}droneHub?token=${droneId}&clientType=1`;
    useEffect(() => {
        if (controlConnection) {
            controlConnection.on("ConfirmStop", onConfirmStop);
            controlConnection.on("Disconnect", onDisconnect);
            controlConnection.on("AddRoutePoint", onAddRoutePoint);
            controlConnection.on("DroneConnected", onDroneConnected1);
            controlConnection.on("Attitude", onAttitude);
            controlConnection.on("ConfirmCommand", commandConfirmationReceived);
            if (controlConnection.state === HubConnectionState.Connected) {
                controlConnection.invoke("Speed", 25);
            }
            let isSubscribed = true;
            let isDroneLost = false;
            const onDroneDisconnected = () => {
                isDroneLost = true;
                stopCruiseControl();
            };
            const onDroneReconnected = () => {
                if (isDroneLost &&
                    controlConnection.state === HubConnectionState.Connected) {
                    isDroneLost = false;
                    controlConnection.invoke("Stop");
                }
            };
            controlConnection.on("DroneDisconnected", onDroneDisconnected);
            controlConnection.on("DroneConnected", onDroneReconnected);
            controlConnection.onreconnecting(() => {
                if (isSubscribed) {
                    stopCruiseControl();
                }
            });
            controlConnection.onreconnected(() => {
                if (isSubscribed) {
                    controlConnection.invoke("Stop");
                }
            });
            return () => {
                isSubscribed = false;
                controlConnection.off("ConfirmStop", onConfirmStop);
                controlConnection.off("Disconnect", onDisconnect);
                controlConnection.off("AddRoutePoint", onAddRoutePoint);
                controlConnection.off("DroneConnected", onDroneConnected1);
                controlConnection.off("Attitude", onAttitude);
                controlConnection.off("ConfirmCommand", commandConfirmationReceived);
                controlConnection.off("DroneDisconnected", onDroneDisconnected);
                controlConnection.off("DroneConnected", onDroneReconnected);
            };
        }
    }, [controlConnection]);
    const isMobilePortrait = useIsMobileDetect();
    useEffect(() => {
        return () => {
            if (stopIntervalRef.current) {
                clearInterval(stopIntervalRef.current);
                stopIntervalRef.current = null;
            }
        };
    }, []);
    useEffect(() => {
        if (isMobilePortrait) {
            mobileActiveRef.current = true;
        }
        else {
            mobileActiveRef.current = false;
        }
    }, [isMobilePortrait]);
    useEffect(() => {
        if (controlConnection &&
            controlConnection.state === HubConnectionState.Connected) {
            controlConnection.invoke("Speed", 25);
        }
    }, [controlConnection, controlConnection === null || controlConnection === void 0 ? void 0 : controlConnection.state]);
    const onConfirmStop = () => {
        setIsStopActive(true);
    };
    const onDisconnect = async () => {
        console.log("Disconnecting");
        setShowModalControlTaken(true);
        if (controlConnection) {
            stickPositions([0, 0, 0, 0, 0, 1, 0]);
            await controlConnection.stop();
        }
        console.log("Disconnected");
    };
    const onDroneConnected1 = () => {
        if (droneId) {
            videoService
                .getCameras(droneId)
                .then((data) => {
                onDroneConnected(data);
                setCameras(data);
            })
                .catch();
        }
    };
    const onAddRoutePoint = (model) => {
        setCurrSpeed(model.speed);
    };
    const onAttitude = (data) => {
        setAngles(data);
    };
    const closeModal = () => {
        setShowModalControlTaken(false);
        navigate("/dashboard");
    };
    const goForward = () => {
        setIsStopActive(false);
        setArrowStraight(true);
    };
    const goBackward = () => {
        setIsStopActive(false);
        setArrowBack(true);
    };
    const stop = () => {
        setArrowStraight(false);
        setArrowBack(false);
        setTurnLeft(false);
        setTurnRight(false);
    };
    const turnLeft = () => {
        setArrowLeft(true);
    };
    const turnRight = () => {
        setArrowRight(true);
    };
    const endTurnLeft = () => {
        setArrowLeft(false);
    };
    const endTurnRight = () => {
        setArrowRight(false);
    };
    const spotTurnLeft = () => {
        setIsStopActive(false);
        setTurnLeft(true);
    };
    const spotTurnRight = () => {
        setIsStopActive(false);
        setTurnRight(true);
    };
    const forceForward = () => {
        setIsStopActive(false);
        setStraightFull(true);
    };
    const forceBackward = () => {
        setIsStopActive(false);
        setBackFull(true);
    };
    const stopForceForward = () => {
        setStraightFull(false);
    };
    const stopForceBackward = () => {
        setBackFull(false);
    };
    const armedStateChanged = (state) => {
        if (isExitingRef.current) {
            return;
        }
        setIsArmed(state);
        if (state === 0 && !stopIntervalRef.current) {
            stopIntervalRef.current = setInterval(() => {
                if (controlConnection &&
                    controlConnection.state === HubConnectionState.Connected) {
                    let ch = [...channelsRef.current];
                    ch[2] = 0;
                    ch[3] = 0;
                    if (isStickSendRef.current) {
                        controlConnection.invoke("StickPositions", ch);
                    }
                    controlConnection.invoke("Stop");
                }
            }, 100);
        }
        else {
            if (stopIntervalRef.current) {
                clearInterval(stopIntervalRef.current);
                stopIntervalRef.current = null;
            }
        }
    };
    const controlTypeChanged = (type) => {
        setControlType(type);
    };
    const commandConfirmationReceived = (commandType) => {
        switch (commandType) {
            case CommandType.Stop:
                setIsStopActive(true);
                setArrowStraight(false);
                setArrowRight(false);
                setArrowBack(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.GoForward:
            case CommandType.ForceForward:
                setIsStopActive(false);
                setArrowStraight(true);
                setArrowRight(false);
                setArrowBack(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.GoBackward:
            case CommandType.ForceBackward:
                setIsStopActive(false);
                setArrowStraight(false);
                setArrowRight(false);
                setArrowBack(true);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.SpotTurnRight:
                setIsStopActive(false);
                setArrowStraight(false);
                setArrowRight(false);
                setArrowBack(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(true);
                setTurnLeft(false);
                break;
            case CommandType.SpotTurnLeft:
                setIsStopActive(false);
                setArrowStraight(false);
                setArrowRight(false);
                setArrowBack(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(true);
                break;
            case CommandType.TurnRight:
                setIsStopActive(false);
                setArrowRight(true);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.TurnLeft:
                setIsStopActive(false);
                setArrowRight(false);
                setArrowLeft(true);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.EndTurnRight:
                setIsStopActive(false);
                setArrowRight(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
            case CommandType.EndTurnLeft:
                setIsStopActive(false);
                setArrowRight(false);
                setArrowLeft(false);
                setStraightFull(false);
                setBackFull(false);
                setTurnRight(false);
                setTurnLeft(false);
                break;
        }
    };
    const controlData = {
        isStraightFull,
        isBackFull,
        isTurnLeft,
        isTurnRight,
        isArrowStraight,
        isArrowBack,
        isArrowRight,
        isArrowLeft,
        isStopActive,
        isArmed,
        onStraightTouchStart: goForward,
        onStraightTouchEnd: stop,
        onRightTouchStart: turnRight,
        onRightTouchEnd: endTurnRight,
        onBackTouchStart: goBackward,
        onBackTouchEnd: stop,
        onLeftTouchStart: turnLeft,
        onLeftTouchEnd: endTurnLeft,
        onTurnLeftTouchStart: spotTurnLeft,
        onTurnLeftTouchEnd: () => setTurnLeft(false),
        onTurnRightTouchStart: spotTurnRight,
        onTurnRightTouchEnd: () => setTurnRight(false),
        onFullForwardTouchStart: forceForward,
        onFullForwardTouchEnd: stopForceForward,
        onFullBackwardTouchStart: forceBackward,
        onFullBackwardTouchEnd: stopForceBackward,
    };
    const startCruiseControl = () => {
        if (isArmed === -1) {
            if (keyboardGasRef.current === null) {
                return;
            }
            cruiseGasRef.current = keyboardGasRef.current;
        }
        else {
            cruiseGasRef.current =
                channelsRef.current[GAMEPAD_CONTROL_CONSTANTS.rightGasAxis];
        }
        setIsCruiseActive(true);
    };
    const stopCruiseControl = () => {
        cruiseGasRef.current = null;
        setIsCruiseActive(false);
    };
    const closeCruiseControl = () => {
        stopCruiseControl();
        setShowCruiseControl(false);
    };
    const exitSession = () => {
        isExitingRef.current = true;
        setIsExiting(true);
        closeCruiseControl();
        if (stopIntervalRef.current) {
            clearInterval(stopIntervalRef.current);
            stopIntervalRef.current = null;
        }
        if (controlConnection &&
            controlConnection.state === HubConnectionState.Connected) {
            if (isStickSendRef.current) {
                const ch = [...channelsRef.current];
                ch[2] = 0;
                ch[3] = 0;
                controlConnection.invoke("StickPositions", ch).catch(() => { });
            }
            controlConnection.invoke("Stop").catch(() => { });
        }
    };
    useEffect(() => {
        stopCruiseControl();
    }, [isArmed]);
    useEffect(() => {
        showCruiseControlRef.current = showCruiseControl;
    }, [showCruiseControl]);
    const stickPositions = (channels) => {
        if (controlConnection && !isExitingRef.current) {
            const { cruiseSwitch, ZERO_THRESHOLD } = GAMEPAD_CONTROL_CONSTANTS;
            const prevCruiseSwitch = channelsRef.current[cruiseSwitch];
            channelsRef.current = [...channels];
            if (channels[cruiseSwitch] != prevCruiseSwitch) {
                if (channels[cruiseSwitch] > ZERO_THRESHOLD &&
                    showCruiseControlRef.current &&
                    cruiseGasRef.current === null) {
                    startCruiseControl();
                }
                else if (channels[cruiseSwitch] <= ZERO_THRESHOLD) {
                    stopCruiseControl();
                }
            }
            if (cruiseGasRef.current !== null) {
                channelsRef.current[GAMEPAD_CONTROL_CONSTANTS.rightGasAxis] =
                    cruiseGasRef.current;
            }
            if (isStickSendRef.current) {
                controlConnection.invoke("StickPositions", channelsRef.current);
            }
        }
    };
    return (_jsxs(_Fragment, { children: [!isViewOnly && !isExiting && (_jsx(OperatorActionsHandler, { isArmed: isArmed, onGoForward: goForward, onGoBackward: goBackward, onStop: stop, onTurnLeft: turnLeft, onTurnRight: turnRight, onEndTurnLeft: endTurnLeft, onEndTurnRight: endTurnRight, onSpotTurnLeft: spotTurnLeft, onSpotTurnRight: spotTurnRight, onForceForward: forceForward, onForceBackward: forceBackward, onStopForceForward: stopForceForward, onStopForceBackward: stopForceBackward, onArmedStateChanged: armedStateChanged, onControlTypeChanged: controlTypeChanged, stickPositions: stickPositions, mobileActiveRef: mobileActiveRef, keyboardActiveRef: keyboardActiveRef, isStickSend: isStickSend, cruiseGasRef: cruiseGasRef, keyboardGasRef: keyboardGasRef, onCruiseStop: stopCruiseControl })), droneId && (_jsx(DroneControlBottomPanel, { droneId: droneId, isArmed: isArmed, onArmedChange: armedStateChanged, isViewOnly: isViewOnly, isFullSpeed: isStraightFull || isBackFull, cameras: cameras, setIsStickSend: setIsStickSend, onCruiseControlClick: () => showCruiseControl
                    ? closeCruiseControl()
                    : setShowCruiseControl(true), isCruiseControlShown: showCruiseControl, onExit: exitSession, setMuteMic: setMuteMic, setMuteAudio: setMuteAudio, setMicVolume: setMicVolume })), !isViewOnly && showCruiseControl && (_jsx(CruiseControl, { isActive: isCruiseActive, onClose: closeCruiseControl, onSet: startCruiseControl, onStop: stopCruiseControl })), !isViewOnly && (_jsx(DirectionControllerWrapper, { cameras: cameras, controlData: controlData, currentSpeed: currSpeed, cameraView: cameraView, angles: angles })), _jsx(DroneControlTopPanel, { controlType: controlType, isViewOnly: isViewOnly }), showModalControlTaken ? (_jsx("div", { className: "modal-wrapper", children: _jsxs("dialog", { open: true, onCancel: closeModal, children: [_jsx("h4", { children: t("droneControlPanel.modal.controlTaken") }), _jsx("div", { className: "text-center", children: _jsx("button", { className: "btn btn-secondary", onClick: closeModal, children: t("droneControlPanel.modal.close") }) })] }) })) : null, isMobilePortrait && !isExiting && (_jsx(DraggableCircle, { controlConnection: controlConnection, stickPositions: stickPositions, isArmed: isArmed, mobileActiveRef: mobileActiveRef, keyboardActiveRef: keyboardActiveRef }))] }));
};
